import { FieldTypeAsset } from '@allesauto/utils/types.d';
import { sbEditable } from '@storyblok/storyblok-editable';
import clsx from 'clsx';
import React from 'react';

import NextImage from '../nextImage';

export interface ISimpleImageComponent {
  link: FieldTypeAsset;
  customClassName?: string;
  withPadding?: boolean;
  component: string;
  _uid: string;
  _editable?: string;
}

const SimpleImageComponent: React.FC<ISimpleImageComponent> = (props) => {
  const { link, customClassName = '', withPadding = false } = props;

  const url = link?.filename ?? null;

  return (
    <div
      {...sbEditable(props)}
      className={clsx(
        'grid grid-cols-24 relative',
        withPadding && 'sm:pt-10px md:pt-20px md:pb-10px',
        customClassName
      )}
    >
      <div className="aspect-video flex flex-row relative sm:col-end-24 sm:col-start-2 md:col-end-24 md:col-start-2">
        {url && (
          <NextImage
            useCustomLoader={false}
            src={url}
            alt={link.alt ?? ''}
            layout="fill"
            objectFit="cover"
          />
        )}
      </div>
    </div>
  );
};

export default SimpleImageComponent;
